import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import '@arcgis/map-components/components/arcgis-map';


// Fix ghost white box on arcgis-expand widgets: patches calcite-panel to inject
// background:transparent into its own shadow root after rendering.
customElements.whenDefined('calcite-panel').then(() => {
  const PanelClass = customElements.get('calcite-panel') as any;
  if (!PanelClass || PanelClass.__ghostFixApplied) return;
  PanelClass.__ghostFixApplied = true;
  const orig = PanelClass.prototype.componentOnReady;
  PanelClass.prototype.componentOnReady = function() {
    return (orig ? orig.call(this) : Promise.resolve(this)).then((result: any) => {
      const shadow = this.shadowRoot;
      if (shadow && !shadow.querySelector('style[data-ghost-fix]')) {
        const s = document.createElement('style');
        s.setAttribute('data-ghost-fix', '');
        s.textContent = ':host { --calcite-color-background: transparent !important; }';
        shadow.appendChild(s);
      }
      return result;
    });
  };
});


// Fix ghost white box on arcgis-expand widgets: patches calcite-panel to inject
// background:transparent into its own shadow root after rendering.
customElements.whenDefined('calcite-panel').then(() => {
  const PanelClass = customElements.get('calcite-panel') as any;
  if (!PanelClass || PanelClass.__ghostFixApplied) return;
  PanelClass.__ghostFixApplied = true;
  const orig = PanelClass.prototype.componentOnReady;
  PanelClass.prototype.componentOnReady = function() {
    return (orig ? orig.call(this) : Promise.resolve(this)).then((result: any) => {
      const shadow = this.shadowRoot;
      if (shadow && !shadow.querySelector('style[data-ghost-fix]')) {
        const s = document.createElement('style');
        s.setAttribute('data-ghost-fix', '');
        s.textContent = ':host { --calcite-color-background: transparent !important; --calcite-panel-background-color: transparent !important; }';
        shadow.appendChild(s);
      }
      return result;
    });
  };
});

console.log(`Unified Frontend starting, using backend at %c${environment.backendUrl}`, 'color: dark-green; font-weight: bold; font-style: underline;');
platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
 
